import * as React from "react";
import * as ReactDOMServer from 'react-dom/server';
import {Button, Card} from "semantic-ui-react";
import {DataTable} from "../../common/DataTable";
import {PostApiService} from "../../../core/api/post/PostApiService";
import {CreatePost} from "./CreatePost";
import {DetailPost} from "./DetailPost";

interface IProps {
    pageId: string;
    pageName: string;
    category: string;
}

interface IState {
    formCreate: JSX.Element;
    formEdit: JSX.Element;
    dataTableComponent: React.RefObject<any>;
}

export class IndexPost extends React.Component<IProps, IState> {

    private readonly apiService = new PostApiService();

    constructor(props: IProps) {
        super(props);

        this.state = {
            formCreate: <div />,
            formEdit: <div />,
            dataTableComponent: React.createRef()
        }
    }

    public render() {

        const columns = [
            {
                title: "Judul",
                data: "title",
                name: "title",
                render: (data: any, type: any, row: any) => {
                    return ReactDOMServer.renderToStaticMarkup(<a href="#" className="dt-column-link" data-access={row.entityId}>{data}</a>);
                }
            },
            {
                title: "Gambar",
                data: "image",
                name: "image",
                render: (data: any, type: any, row: any) => {
                    return ReactDOMServer.renderToStaticMarkup(<a href={data} target='_blank'>Lihat</a>);
                }
            }
        ];

        return (
            <div id={this.props.pageId}>

                <Card fluid={true}>
                    <Card.Content>
                        <Button onClick={this.renderCreateForm} floated="right" primary={true}>Tambah</Button>
                        <Card.Header>{this.props.pageName}</Card.Header>

                    </Card.Content>
                    <Card.Content>
                        <DataTable
                            tableId={"DtPost_" + this.props.pageId}
                            ref={this.state.dataTableComponent}
                            url={this.apiService.getDtJsonUrl()}
                            detailViewHandler={this.renderDetailForm}
                            ajaxCustomParameter={{
                                category: this.props.category
                            }}
                            columns={columns}
                        />

                    </Card.Content>
                </Card>

                {this.state.formCreate}
                {this.state.formEdit}
            </div>
        );
    }

    private renderCreateForm = () => {
        this.setState({
            formCreate: <CreatePost
                category={this.props.category}
                onSuccessRequest={this.onSuccessCreate}
                onCancelForm={this.clearMaintenanceForm} />
        });
    };

    private renderDetailForm = (accessToken: string) => {
        this.clearMaintenanceForm();
        this.setState({
            formEdit: <DetailPost
                id={accessToken}
                onSuccessRequest={this.onSuccessCreate}
                onCancelForm={this.clearMaintenanceForm} />
        });
    };

    private onSuccessCreate = () => {
        this.clearMaintenanceForm();
        this.state.dataTableComponent.current.reloadTable();

    };

    private clearMaintenanceForm = () => {
        this.setState({
            formCreate: <div />,
            formEdit: <div />
        });
    }
}


// WEBPACK FOOTER //
// ./src/component/admin/post/IndexPost.tsx